import { Action } from '@ngrx/store';

export class ExchangeActions implements Action {

    public static getClientOrders: string = '[FINANCE] getClientOrders';
    public static getClientOrdersError: string = '[FINANCE] getClientOrdersError';
    public static getClientOrdersSuccess: string = '[FINANCE] getClientOrdersSuccess';

    public static closeStrategy = '[Exchange] close_strategy';
    public static closeStrategyError = '[Exchange] close_strategy_error';
    public static closeStrategySuccess = '[Exchange] close_strategy_success';
    public static closeStrategyInvalidToken = '[Exchange] close_strategy_invalid_token';

    public static closeOrder = '[Exchange] close_order';
    public static closeOrderError = '[Exchange] close_order_error';
    public static closeOrderSuccess = '[Exchange] close_order_success';
    public static closeOrderInvalidToken = '[Exchange] close_order_invalid_token';

    public static cancelOrder = '[Exchange] cancel_order';
    public static cancelOrderError = '[Exchange] cancel_order_error';
    public static cancelOrderSuccess = '[Exchange] cancel_order_success';
    public static cancelOrderInvalidToken = '[Exchange] cancel_order_invalid_token';

    public static cancelStrategy = '[Exchange] cancel_strategy';
    public static cancelStrategyError = '[Exchange] cancel_strategy_error';
    public static cancelStrategySuccess = '[Exchange] cancel_strategy_success';
    public static cancelStrategyInvalidToken = '[Exchange] cancel_strategy_invalid_token';

    public static getTradingTime = '[Exchange] get_trading_time';
    public static getTradingTimeError = '[Exchange] get_trading_time_error';
    public static getTradingTimeSuccess = '[Exchange] get_trading_time_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
